import React from 'react';

import PriceBlockWithTextCard, {
  PriceBlockWithTextCardProps,
} from '../PriceBlockWithTextCard';
import TextBlock, { TextBlockProps } from '../TextBlock';

import styles from './index.module.scss';

export interface PricingSectionProps {
  textBlock: TextBlockProps;
  cards: PriceBlockWithTextCardProps[];
}

const PricingSection: React.FC<PricingSectionProps> = ({
  textBlock,
  cards,
}) => {
  return (
    <div className={styles.wrapper}>
      {textBlock && <TextBlock {...textBlock} />}
      {cards &&
        cards.length > 0 &&
        cards.map((card, index) => (
          <PriceBlockWithTextCard key={index} {...card} />
        ))}
    </div>
  );
};

export default PricingSection;
